// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1mCI2","label":"SetPasswdForm_label__1dgrm"};